import { appconfig } from './config';
import Logger from './helpers/logger';
import $ from 'jquery';
window.jQuery = $;
require('ms-signalr-client');



export default class {
    static connect(callback) {
        var config = appconfig();
        var connection = $.hubConnection(config.SIGNALRserv);
        var proxy = connection.createHubProxy('default');

        // receives broadcast messages from a hub function, called "broadcastMessage"
        proxy.on('update', function (message) {
            Logger.log('SignalR message:', message);
            if (callback) callback(message);
        });

        // atempt connection, and handle errors
        connection.start({ jsonp: true })
            .done(function () { Logger.log('Signalr now connected, connection ID=' + connection.id); })
            .fail(function () { Logger.log('Signalr could not connect'); });

        connection.disconnected(function () {
            setTimeout(function () {
                this.connect(callback);
            }, 5000); // Restart connection after 5 seconds.
        });
    }
}


// WEBPACK FOOTER //
// ./app/signalr.js